import { render, staticRenderFns } from "./document-pdf-body.vue?vue&type=template&id=2068dd7c&scoped=true&"
import script from "./document-pdf-body.vue?vue&type=script&lang=js&"
export * from "./document-pdf-body.vue?vue&type=script&lang=js&"
import style0 from "./document-pdf-body.vue?vue&type=style&index=0&id=2068dd7c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2068dd7c",
  null
  
)

export default component.exports